module.exports = __webpack_public_path__ + "img/morocco.4a78c98e.png";